// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKBadge from "components/MKBadge";
import MKTypography from "components/MKTypography";
import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";
import DefaultReviewCard from "examples/Cards/ReviewCards/DefaultReviewCard";

// Presentation page sections
// import Counters from "pages/Presentation/sections/Counters";
// import Information from "pages/Presentation/sections/Information";
// import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
// import Pages from "pages/Presentation/sections/Pages";
import Testimonials from "pages/Presentation/sections/Testimonials";
import Download from "pages/Presentation/sections/Download";

// Presentation page components
// import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
import { routes } from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/somosure/enthusiastic-afroamerican-model-studio-shot.jpg";

function Presentation() {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "/auth/login",
          label: "Login",
          color: "info",
        }}
        sticky
      />
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="white"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Somosure{" "}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="white"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              Your leading Insurance company in Africa delivering solution that
              de-risk individuals and businesses from the uncertainties.
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
            rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        {/* <Counters />
        <Information />
        <DesignBlocks />
        <Pages />
        <Container sx={{ mt: 6 }}>
          <BuiltByDevelopers />
        </Container> */}
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={6}
            flexDirection="column"
            alignItems="center"
            sx={{ textAlign: "center", my: 6, mx: "auto", px: 0.75 }}
          >
            <MKBadge
              variant="contained"
              color="info"
              badgeContent="Infinite combinations"
              container
              sx={{ mb: 2 }}
            />
            <MKTypography variant="h2" fontWeight="bold">
              COMPARE and SAVE on Your INSURANCE
            </MKTypography>
            <MKTypography variant="body1" color="text">
              We have curated multiple sections for you to browse.
            </MKTypography>
          </Grid>
        </Container>
        {/* <Container>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={3}>
              <FilledInfoCard
                variant="gradient"
                color="info"
                icon="flag"
                title="COMPREHENSIVE"
                description="Car Insurance."
                action={{
                  type: "internal",
                  route: "/motor/comprehensive",
                  label: "Explore",
                }}
              />
            </Grid>
            <Grid item xs={12} lg={3}>
              <FilledInfoCard
                color="info"
                icon="precision_manufacturing"
                title="JUNIOR HEALTH"
                description="Health Insurance."
                action={{
                  type: "internal",
                  route: "/health/junior_health_plans",
                  label: "Explore",
                }}
              />
            </Grid>
            <Grid item xs={12} lg={3}>
              <FilledInfoCard
                variant="gradient"
                color="info"
                icon="flag"
                title="EDUCATION"
                description="Life Insurance."
                action={{
                  type: "internal",
                  route: "/life/education_insurance",
                  label: "Explore",
                }}
              />
            </Grid>
            <Grid item xs={12} lg={3}>
              <FilledInfoCard
                color="info"
                icon="apps"
                title="FAMILY HEALTH"
                description="Health Insurance."
                action={{
                  type: "internal",
                  route: "/health/family_health_plans",
                  label: "Explore",
                }}
              />
            </Grid>
            <Grid item xs={12} lg={3}>
              <FilledInfoCard
                variant="gradient"
                color="info"
                icon="flag"
                title="LIFE"
                description="Life Insurance."
                action={{
                  type: "internal",
                  route: "/life/life_insurance",
                  label: "Explore",
                }}
              />
            </Grid>
            <Grid item xs={12} lg={3}>
              <FilledInfoCard
                color="info"
                icon="precision_manufacturing"
                title="THIRD PARTY"
                description="Car Insurance."
                action={{
                  type: "internal",
                  route: "/motor/third_party_only",
                  label: "Explore",
                }}
              />
            </Grid>
            <Grid item xs={12} lg={3}>
              <FilledInfoCard
                variant="gradient"
                color="info"
                icon="flag"
                title="SENIOR'S HEALTH"
                description="Health Insurance."
                action={{
                  type: "internal",
                  route: "/health/seniors_health_plans",
                  label: "Explore",
                }}
              />
            </Grid>
            <Grid item xs={12} lg={3}>
              <FilledInfoCard
                color="info"
                icon="apps"
                title="MOTOR PSV"
                description="Motor Psv Insurance."
                action={{
                  type: "internal",
                  route: "/motor/motor_psv",
                  label: "Explore",
                }}
              />
            </Grid>
          </Grid>
        </Container> */}
        <Divider sx={{ my: 6 }} />
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={6}
            flexDirection="column"
            alignItems="center"
            sx={{ textAlign: "center", my: 6, mx: "auto", px: 0.75 }}
          >
            <MKTypography variant="h2" fontWeight="bold">
              How Somosure Works
            </MKTypography>
            <MKTypography variant="body1" color="text">
              BUY Your Insurance Policy ONLINE at www.somosure.com
            </MKTypography>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={3}>
              <DefaultReviewCard
                color="info"
                name="Enter your details"
                date="Step 1"
                review="Give us A Few Mandatory Details."
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <DefaultReviewCard
                name="COMPARE"
                date="Step 2"
                review="We’ll Find Suitable COVER, COMPARE And Choose The Best Policy For You."
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <DefaultReviewCard
                color="info"
                name="BUY ONLINE"
                date="Step 3"
                review="Pay ONLINE And Receive Your E-policy Instantly."
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <DefaultReviewCard
                name="We'll CALL You.."
                date="Step 4"
                review="We’ll CALL You Promptly To Make Sure You Are Happy With Your COVER."
              />
            </Grid>
          </Grid>
        </Container>
        <Testimonials />
        {/* <Download /> */}
        <MKBox pt={6} pb={6}>
          <Container>
            <Grid container spacing={3}>
              <Grid
                item
                xs={12}
                lg={5}
                ml="auto"
                sx={{ textAlign: { xs: "center", lg: "left" } }}
              >
                <MKTypography variant="h4" fontWeight="bold" mb={0.5}>
                  Thank you for your support!
                </MKTypography>
                <MKTypography variant="body1" color="text">
                  We deliver the best insurance deals
                </MKTypography>
              </Grid>
              <Grid
                item
                xs={12}
                lg={5}
                my={{ xs: 5, lg: "auto" }}
                mr={{ xs: 0, lg: "auto" }}
                sx={{ textAlign: { xs: "center", lg: "right" } }}
              >
                <MKSocialButton
                  component="a"
                  href="#"
                  target="_blank"
                  color="twitter"
                  sx={{ mr: 1 }}
                >
                  <i className="fab fa-twitter" />
                  &nbsp;Tweet
                </MKSocialButton>
                <MKSocialButton
                  component="a"
                  href="#"
                  target="_blank"
                  color="facebook"
                  sx={{ mr: 1 }}
                >
                  <i className="fab fa-facebook" />
                  &nbsp;Share
                </MKSocialButton>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Presentation;
